import React from 'react'
import PropTypes from 'prop-types'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

const BrowserView = ({ children }) => {
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.up('sm'))

  if (matches) {
    return <>{children}</>
  }
  return null
}

BrowserView.propTypes = {
  children: PropTypes.node.isRequired,
}

export default BrowserView
